import { render, staticRenderFns } from "./DadosAdicionais.vue?vue&type=template&id=8bdee000&"
import script from "./DadosAdicionais.vue?vue&type=script&lang=js&"
export * from "./DadosAdicionais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports